import React from 'react';

import { TagList as SharedTagList } from '../../../../../shared/components/Filter';
import { useDecedentFilters } from '../../../hooks';

const TagList = () => {
  const {
    activeFilters: { tags: selectedIds },
    filterOptions: { tags },
    toggleFilter,
  } = useDecedentFilters();

  return (
    <SharedTagList
      onToggle={(value) => toggleFilter({ type: 'tags', value })}
      selectedIds={selectedIds}
      tags={tags}
    />
  );
};

export default TagList;
